import { useEffect, useRef, useState } from "react";
import { Center, Button, Stack, Loader, Text } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router";
import { notifications } from "@mantine/notifications";
import { adminSend, adminErrText, AdminApiError } from "../api.ts";

export function TikTokOAuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // OAuth code 一次性：StrictMode 双调用 effect 只允许兑换一次
  const exchangedRef = useRef(false);

  useEffect(() => {
    // TikTok 回调参数名为 auth_code，兼容 code
    const authCode = params.get("auth_code") ?? params.get("code");
    const state = params.get("state");
    const botId = sessionStorage.getItem("tiktok_oauth_botId");

    if (authCode === null || state === null || botId === null) {
      setError(`OAuth 回调缺少必要参数（auth_code/state/botId），请重新发起授权。`);
      return;
    }
    if (exchangedRef.current) return;
    exchangedRef.current = true;

    void (async () => {
      try {
        await adminSend("POST", `/analytics/${botId}/tiktok/oauth-exchange`, {
          authCode,
          state,
        });
        sessionStorage.removeItem("tiktok_oauth_botId");
        notifications.show({ color: "green", message: "TikTok 授权成功" });
        void navigate(`/bots/${botId}/credentials/tiktok`, { replace: true });
      } catch (e) {
        const err = e as AdminApiError;
        setError(`${err.code}: ${err.message}`);
        notifications.show({ color: "red", message: adminErrText(err.code) });
      }
    })();
  }, [params, navigate]);

  if (error !== null) {
    const botId = sessionStorage.getItem("tiktok_oauth_botId");
    return (
      <Center style={{ minHeight: "100vh" }}>
        <Stack align="center" gap="md">
          <Text fw={600} size="lg">
            TikTok 授权失败
          </Text>
          <Text c="red" size="sm">
            {error}
          </Text>
          <Button
            onClick={() =>
              void navigate(botId !== null ? `/bots/${botId}/credentials/tiktok` : "/", {
                replace: true,
              })
            }
          >
            返回
          </Button>
        </Stack>
      </Center>
    );
  }

  return (
    <Center style={{ minHeight: "100vh" }}>
      <Stack align="center" gap="sm">
        <Loader size="lg" />
        <Text c="dimmed">正在完成 TikTok 授权...</Text>
      </Stack>
    </Center>
  );
}
